// extracted by mini-css-extract-plugin
export default {"pageLoading":"index-module--page-loading--zyoIB"};